import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function LinkForm({ link, editForm, submitForm }: Props) {
  const { t } = useTranslation();
  const hasName = !!link.name;
  const hasUrl = !!link.url;

  return (
    <div className={styles.linkForm}>
      <div className={styles.group}>
        <p className={styles.label}>Nom</p>
        <input
          className={styles.input}
          placeholder={t("projectExternalLinks.namePlaceholder")}
          value={link.name}
          onBlur={() => hasName && hasUrl && submitForm(link)}
          onChange={({ target }) => editForm({ ...link, name: target.value })}
        />
      </div>
      <div className={classNames(styles.group, styles.url)}>
        <p className={styles.label}>Lien</p>
        <input
          className={styles.input}
          placeholder={t("projectExternalLinks.urlPlaceholder")}
          value={link.url}
          onBlur={() => hasName && hasUrl && submitForm(link)}
          onChange={({ target }) => editForm({ ...link, url: target.value })}
        />
      </div>
    </div>
  );
}

export { LinkForm };
